import {configureFonts, MD2LightTheme} from 'react-native-paper';

export const defaultTheme = {
  colors: {
    primary: '#F34F42',
    primaryLighter: '#F4665A',
    primaryLighter2: '#F78B83',
    secondary: '#B91618',
    secondaryLighter: '#C23436',
    secondaryLighter2: '#D16667',
    whiteGrey0: '#FFFFFF',
    grey0_5: '#F7F7F7',
    grey1: '#EAEAEA',
    grey1_5: '#DCDCDC',
    grey2: '#CFCFCF',
    grey3: '#C1C1C1',
    grey4: '#A6A6A6',
    grey5: '#8B8B8B',
    grey6: '#707070',
    grey7: '#5A5A5A',
    grey8: '#434343',
    grey8_5: '#2D2D2D',
    grey9: '#222222',
    grey9_5: '#161616',
    grey10: '#0B0B0B',
    grey200: '#CACACD',
    purple0: '#F5F7FF',
    purple100: '#EDF0FD',
    purple200: '#D9DFF9',
    purple300: '#B8C3F3',
    purple400: '#5A5A5A',
    purple500: '#6077DE',
    purple600: '#3B56CE',
    purple700: '#223EB9',
    purple800: '#142EA2',
    errorMain: '#F74B4A',
    errorDarker: '#F2302F',
    errorLighter: '#F87878',
    infoMain: '#2BBEF2',
    infoDarker: '#1B93C0',
    infoLighter: '#BFEEFF',
    successMain: '#61D215',
    successDarker: '#51A915',
    successLighter: '#B7F28F',
    warningMain: '#FF9D00',
    warningDarker: '#E58D00',
    warningLighter: '#FFBA4B',
    eerieBlack: '#181819',
    darkCharcoal: '#313135',
    raisinBlack: '#202023',
    davysGrey: '#575757',
    silverChalice: '#ABABAB',
    red600: '#E31C1C',
    oldPrimary: '#303261',
    red0: '#FFF5F5',
    red800: '#CA1515',
  },
};

export const colorPalette = {
  primary: '#F34F42',
  primaryLighter: '#F4665A',
  primaryLighter2: '#F78B83',
  secondary: '#B91618',
  secondaryLighter: '#C23436',
  secondaryLighter2: '#D16667',
  whiteGrey0: '#FFFFFF',
  grey0_6: '#f7f7f7ff',
  grey0_5: '#F7F7F7',
  grey1: '#EAEAEA',
  grey1_5: '#DCDCDC',
  grey2: '#CFCFCF',
  grey3: '#C1C1C1',
  grey4: '#A6A6A6',
  grey5: '#8B8B8B',
  grey6: '#707070',
  grey7: '#5A5A5A',
  grey8: '#434343',
  grey8_5: '#2D2D2D',
  grey9: '#222222',
  grey9_5: '#161616',
  grey10: '#0B0B0B',
  grey200: '#CACACD',
  purple0: '#F5F7FF',
  purple100: '#EDF0FD',
  purple200: '#D9DFF9',
  purple300: '#B8C3F3',
  purple400: '#8D9EEA',
  purple500: '#6077DE',
  purple600: '#3B56CE',
  purple700: '#223EB9',
  purple800: '#142EA2',
  errorMain: '#F74B4A',
  errorDarker: '#F2302F',
  errorLighter: '#F87878',
  infoMain: '#2BBEF2',
  infoDarker: '#1B93C0',
  infoLighter: '#BFEEFF',
  successMain: '#61D215',
  successDarker: '#51A915',
  successLighter: '#B7F28F',
  warningMain: '#FF9D00',
  warningDarker: '#E58D00',
  warningLighter: '#FFBA4B',
  eerieBlack: '#181819',
  darkCharcoal: '#313135',
  raisinBlack: '#202023',
  davysGrey: '#575757',
  silverChalice: '#ABABAB',
  red600: '#E31C1C',
  oldPrimary: '#303261',
  red0: '#FFF5F5',
  firefly: '#022532',
  green900: '#06AD00',
  green: '#09CF02',
  red300: '#F84444',
  green600: '#0DDD06',
  gunmetal: '#27303A',
  lavenderGray: '#CFCDC0',
  red800: '#CA1515',
  green0: '#F5FFF5',
  oldPrimaryLight: 'rgba(48, 50, 97, 0.3)',
};

enum FontWeight {
  Thin = 100,
  ExtraLight = 200,
  Light = 300,
  Regular = 400,
  Medium = 500,
  SemiBold = 600,
  Bold = 700,
  ExtraBold = 800,
}

const fontConfig: any = {
  web: {
    regular: {
      fontFamily: 'IRANYekan',
      fontWeight: 'normal',
    },
    medium: {
      fontFamily: 'IRANYekan',
      fontWeight: 'normal',
    },
    light: {
      fontFamily: 'IRANYekan',
      fontWeight: 'normal',
    },
    thin: {
      fontFamily: 'IRANYekan',
      fontWeight: 'normal',
    },
  },
  ios: {
    regular: {
      fontFamily: 'IRANYekan',
      fontWeight: 'normal',
    },
    medium: {
      fontFamily: 'IRANYekan',
      fontWeight: 'normal',
    },
    light: {
      fontFamily: 'IRANYekan',
      fontWeight: 'normal',
    },
    thin: {
      fontFamily: 'IRANYekan',
      fontWeight: 'normal',
    },
  },
  android: {
    regular: {
      fontFamily: 'IRANYekan',
      fontWeight: 'normal',
    },
    medium: {
      fontFamily: 'IRANYekan',
      fontWeight: 'normal',
    },
    light: {
      fontFamily: 'IRANYekan',
      fontWeight: 'normal',
    },
    thin: {
      fontFamily: 'IRANYekan',
      fontWeight: 'normal',
    },
  },
};

export const paperTheme = {
  ...MD2LightTheme,
  fonts: configureFonts({config: fontConfig, isV3: false}),
};

export const textStyles = {
  regular: 'IRANYekan',
  medium: 'IRANYekanMedium',
  bold: 'IRANYekanBold',
  extraBold: 'IRANYekanExtraBoldFaNum',
};
